import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { ErrorDetails } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class EditClientCommand extends IRequestCommand<
  IEditClientResponse,
  ErrorDetails,
  IEditClientParameters
> {
  constructor(carrierUserId: string, clientId: string) {
    super();
    this._commandType = CommandRequestType.PUT;
    this._commandUrl = 'carriers/{carrierUserId}/clients/{clientId}';
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      carrierUserId
    );
    this._commandUrl = this._commandUrl.replace('{clientId}', clientId);
  }
}

export interface IEditClientParameters extends ICommandParameters {
  passengerAccountId: number;
  fareId?: number;
}

export interface IEditClientResponse extends ICommandResponse {}
